"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _PanelContext = _interopRequireDefault(require("../../PanelContext"));

var sc = _interopRequireWildcard(require("./Header.styles"));

var _excluded = ["children", "getPushContentElement", "hasAccent", "hasCloseButton", "isCloseButtonSemantic", "onClose"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Header = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var size = _react["default"].useContext(_PanelContext["default"]).size;

  var children = props.children,
      getPushContentElement = props.getPushContentElement,
      hasAccent = props.hasAccent,
      hasCloseButton = props.hasCloseButton,
      isCloseButtonSemantic = props.isCloseButtonSemantic,
      onClose = props.onClose,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(sc.Header, (0, _extends2["default"])({
    "data-pka-anchor": "panel.header",
    hasPushedElement: !!getPushContentElement,
    hasAccent: hasAccent,
    size: size,
    ref: ref
  }, moreProps), children, hasCloseButton && /*#__PURE__*/_react["default"].createElement(_button["default"].Close, {
    "data-pka-anchor": "panel.header.close",
    isSemantic: isCloseButtonSemantic,
    onClick: onClose,
    size: _button["default"].types.size.MEDIUM
  }));
});

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  getPushContentElement: _propTypes["default"].func,
  hasAccent: _propTypes["default"].bool,
  hasCloseButton: _propTypes["default"].bool,
  isCloseButtonSemantic: _propTypes["default"].bool,
  isHeaderSticky: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
var defaultProps = {
  getPushContentElement: function getPushContentElement() {},
  hasCloseButton: true,
  hasAccent: false,
  isCloseButtonSemantic: true,
  isHeaderSticky: false,
  onClose: function onClose() {}
};
Header.displayName = "Panel.Header";
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map